"use strict";

import React from 'react';
import AppStore from '../stores/AppStore';
import headerLogo from '../../assets-virgin/images/virgin_logo_top_bar.png';

/**
 * Maintenance page shown while the migration deployment is verified.
 *
 * The header carries the logo only and nothing on the page is navigable, so a
 * customer cannot route away while maintenance mode is active. The logo is a
 * plain element rather than a Link for the same reason.
 */
export default class MaintenancePage extends React.Component {
    render() {
        return (
            <div className="maintenance-page">
                <header className="maintenance-page__header" role="banner">
                    <div
                        className="maintenance-page__logo"
                        style={{backgroundImage: `url(${headerLogo})`}}
                        role="img"
                        aria-label={AppStore.translate('view.maintenance_page.logo_alt')}
                    />
                </header>
                <div className="maintenance-page__content">
                    <h1 className="maintenance-page__message">
                        {AppStore.translate('view.maintenance_page.message')}
                    </h1>
                </div>
            </div>
        );
    }
}
